/**
 * This file is auto-generated by the build/release process.
 * DO NOT MODIFY.
 */
const releaseName = 'zmyle-www-ui:20261104211534:master:747375d81b49520e600058bfc5f3b852487e48b2';
const dirname = __dirname;

exports = module.exports = (() => {
  const data = releaseName.split(':');
  if (data.length !== 4) {
    throw Error(
      `No proper release info generated during build phase: '${releaseName}'`,
    );
  }
  return {
    name: String(data[0]),
    gitBranch: String(data[2]),
    gitCommit: String(data[3]),
    releasedAt: String(data[1]),
    release: releaseName,
    __projectRootDirname: dirname,
  };
})();
